import React, { createContext, useContext, useEffect, useState } from "react";
import socket from "../../src/utility/socket";
import { toast } from "react-toastify";
import OrderToast from "../utility/component/ordertoast";
import { ToastsError } from "../shared/components/Toasts";
import riderAssign from "../shared/components/riderAssign.mp3";
import outForDelivery from "../shared/components/outForDelivery.wav";
import orderrDelivered from "../shared/components/completeSuccess.wav";
import searchingRider from "../shared/components/searchingRider.wav";
import { useHistory } from "react-router-dom";
const SocketContext = createContext(null);

export const SocketProvider = ({ children }) => {
  const history = useHistory();

  const redirectOrder = (orderId) => {
    console.log("Redirect Order Id ::", orderId);
    history.push(`/order-detail/${orderId}`); // TODO : Fix this issue
  };

  const showOrderNotification = (order) => {
    if (order) {
      toast.info(
        ({ closeToast }) => (
          <OrderToast order={order} closeToast={closeToast} />
        ),
        {
          autoClose: false,
          closeOnClick: false,
          closeButton: false,
          hideProgressBar: true,
          className: "custom-toast-center",
        }
      );
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    const localUser = JSON.parse(localStorage.getItem("userData"));
    if (token) {
      let socket;
      let reconnectTimer;
      let isUnmounted = false; // flag to avoid reconnection attempts after unmounting
      // Function to establish WebSocket connection
      const connect = () => {
        socket = new WebSocket(`${process.env.REACT_APP_SOCKET_URL}${token}`);

        // When connection is open
        socket.onopen = () => {
          console.log("Connected to Spring WebSocket server");
        };

        // When a message is received
        socket.onmessage = (event) => {
          console.log("Received notification:", event.data);

          // Parse JSON data and set notification message.
          try {
            if (event && event?.data) {
              const notification = event.data ? JSON.parse(event.data) : {};
              // {
              //   eventType: "NEW_ORDER",
              //   orderId: 1605,
              //   message: "A new order has been placed. Order ID: 1605",
              //   timestamp: 1745252070901,
              //   jsonString:
              //     '{"expectedPickupTime":"2001-04-22 00:00:00.0","orderType":"pickup","orderPlacedDate":"2025-04-21 21:44:17.888","uniqueNumber":"O20250401193","expectedDeliveryDate":"1970-01-01 05:30:00.015","totalAmount":260.0,"storeName":"Nio Mart","customerName":"Taruna"}',
              // };

              if (
                notification?.eventType === "NEW_ORDER" &&
                (localUser.roles[0].name === "Super User" ||
                  localUser.roles[0].name === "Store Owner")
              ) {
                showOrderNotification(notification);
              } else if (
                notification?.eventType === "DRIVER_ASSIGNED" &&
                localUser.roles[0].name === "Super User"
              ) {
                const audio = new Audio(riderAssign);
                audio.play();
              } else if (
                notification?.eventType === "OUT_FOR_PICKUP" &&
                localUser.roles[0].name === "Super User"
              ) {
                const audio = new Audio(riderAssign); //TODO : ring update
                audio.play();
              } else if (
                notification?.eventType === "OUT_FOR_DELIVERY" &&
                (localUser.roles[0].name === "Super User" ||
                  localUser.roles[0].name === "Store Owner")
              ) {
                const audio = new Audio(outForDelivery);
                audio.play();
              } else if (
                notification?.eventType === "ORDER_DELIVERED" &&
                localUser.roles[0].name === "Super User"
              ) {
                const audio = new Audio(orderrDelivered);
                audio.play();
              } else if (
                notification?.eventType === "SEARCHING_RIDER" &&
                localUser.roles[0].name === "Super User"
              ) {
                const audio = new Audio(searchingRider);
                audio.play();
              } else if (
                notification?.eventType === "DRIVER_CANCELLED" &&
                localUser.roles[0].name === "Super User"
              ) {
                showOrderNotification(notification);
              } else if (
                notification?.eventType === "AI_INVENTORY_ALERT" &&
                (localUser.roles[0].name === "Super User" ||
                  localUser.roles[0].name === "Store Owner")
              ) {
                ToastsError(notification.message);
              }
            } else {
              console.log("Not receive event data");
            }
          } catch (err) {
            console.error("Error parsing notification JSON:", err);
          }

          // Play the ringtone sound.
          // Note: Some browsers may require user interaction before audio can play.
          // audio.play().catch((err) => {
          //   console.error('Audio play failed:', err);
          // });
        };

        // Handle errors
        socket.onerror = (error) => {
          console.error("WebSocket error:", error);
        };

        // When connection closes, attempt to reconnect automatically
        socket.onclose = (event) => {
          console.log("Disconnected from Spring WebSocket server", event);
          // Only attempt reconnection if the component is still mounted
          if (!isUnmounted) {
            reconnectTimer = setTimeout(() => {
              console.log("Attempting to reconnect...");
              connect();
            }, 3000); // 60000 Reconnect after 60 seconds (adjust as needed)
          }
        };
      };

      // Initialize the connection
      connect();

      // Cleanup on component unmount
      return () => {
        isUnmounted = true;
        if (socket) {
          socket.close();
        }
        if (reconnectTimer) {
          clearTimeout(reconnectTimer);
        }
      };
    }
  }, []);

  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);
